import SelectColorDialog from "./SelectColorDialog";
import { jsx as _jsx } from "react/jsx-runtime";
export default function initializeSelectIcon(selectColor, prevId) {
  var popupEvent = new CustomEvent("openPopup", {
    detail: {
      prevId: prevId,
      C: function C() {
        return /*#__PURE__*/_jsx(SelectColorDialog, {
          prevId: prevId,
          selectColor: selectColor
        });
      }
    }
  });
  window.dispatchEvent(popupEvent);
}